'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _vkbeautify = require('vkbeautify');

var _vkbeautify2 = _interopRequireDefault(_vkbeautify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CodeMirror = function (_React$Component) {
	_inherits(CodeMirror, _React$Component);

	function CodeMirror() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CodeMirror);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CodeMirror.__proto__ || Object.getPrototypeOf(CodeMirror)).call.apply(_ref, [this].concat(args))), _this), _this.initEditor = function () {

			var codeMirrorInstance = wp.CodeMirror;

			_this.codeMirror = codeMirrorInstance.fromTextArea(_this.refs.editor, {
				lineNumbers: true,
				lineWrapping: true,
				mode: "xml"
			});

			_this.codeMirror.on('change', _this.codemirrorValueChanged);
			_this.codeMirror.setValue(_vkbeautify2.default.xml(_this.props.code || ''));
			// this.codeMirror.on('cursorActivity', this.cursorActivity);
			// this.codeMirror.on('focus', this.focusChanged.bind(this, true));
			// this.codeMirror.on('blur', this.focusChanged.bind(this, false));
			// this.codeMirror.on('scroll', this.scrollChanged);
		}, _this.codemirrorValueChanged = function (doc, change) {
			if (_this.props.onChange && change.origin !== 'setValue') {
				_this.props.onChange(doc.getValue(), change);
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CodeMirror, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.initEditor();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			// is there a lighter-weight way to remove the cm instance?
			if (this.codeMirror) {
				this.codeMirror.toTextArea();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'CodeMirrorEditor' },
				_react2.default.createElement('textarea', {
					ref: 'editor',
					defaultValue: this.props.code
				})
			);
		}
	}]);

	return CodeMirror;
}(_react2.default.Component);

exports.default = CodeMirror;


//////////////////
// WEBPACK FOOTER
// ./src/components/CodeMirror.js
// module id = 263
// module chunks = 0 1